module.exports = __webpack_public_path__ + "static/media/RapGod.37824590.JPG";